'use client';

import { create } from 'zustand';
import type { Id } from 'convex/_generated/dataModel';

interface MyGardensStore {
  createDialogOpen: boolean;
  newGardenName: string;
  editDialogOpen: boolean;
  editingGarden: Id<'gardens'> | null;
  editName: string;
  deleteDialogOpen: boolean;
  gardenToDelete: Id<'gardens'> | null;
  isSaving: boolean;

  setIsSaving: (isSaving: boolean) => void;
  startCreating: () => void;
  cancelCreating: () => void;
  setNewGardenName: (name: string) => void;
  startEditing: (gardenId: Id<'gardens'>, currentName: string) => void;
  cancelEditing: () => void;
  setEditName: (name: string) => void;
  confirmDelete: (gardenId: Id<'gardens'>) => void;
  cancelDelete: () => void;
}

export const useMyGardensStore = create<MyGardensStore>((set) => ({
  createDialogOpen: false,
  newGardenName: '',
  editDialogOpen: false,
  editingGarden: null,
  editName: '',
  deleteDialogOpen: false,
  gardenToDelete: null,
  isSaving: false,

  setIsSaving: (isSaving) => set({ isSaving }),
  startCreating: () => set({ createDialogOpen: true }),
  cancelCreating: () => set({ createDialogOpen: false, newGardenName: '' }),
  setNewGardenName: (name) => set({ newGardenName: name }),
  startEditing: (gardenId, currentName) =>
    set({ editingGarden: gardenId, editName: currentName, editDialogOpen: true }),
  cancelEditing: () => set({ editingGarden: null, editName: '', editDialogOpen: false }),
  setEditName: (name) => set({ editName: name }),
  confirmDelete: (gardenId) => set({ gardenToDelete: gardenId, deleteDialogOpen: true }),
  cancelDelete: () => set({ gardenToDelete: null, deleteDialogOpen: false }),
}));
